export const TM_MostCommon_Images = {
  welcome_screen: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/menuImage.jpg`,
  dataflow_name_logo: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/dataFlowLogoOps.png`,
  dataflow_logo: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/verify.png`,
  opsStartScreen: `${process.env.NEXT_PUBLIC_STATIC_URL}/images/opsStartScreen/Internal_new.png`
};
